import { useEffect, useRef, useState } from "react";

/** A dropdown fixed to the viewport so a table's scroll box never clips it; opens upward near the bottom. */
export function useFixedMenu(menuH, menuW) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState(null);
  const box = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    const esc = (e) => { if (e.key === "Escape") setOpen(false); };
    const moved = (e) => { if (!box.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", away);
    window.addEventListener("keydown", esc);
    window.addEventListener("scroll", moved, true);
    window.addEventListener("resize", moved);
    return () => {
      document.removeEventListener("mousedown", away); window.removeEventListener("keydown", esc);
      window.removeEventListener("scroll", moved, true); window.removeEventListener("resize", moved);
    };
  }, [open]);

  const toggle = (e) => {
    if (open) { setOpen(false); return; }
    const r = e.currentTarget.getBoundingClientRect();
    const up = window.innerHeight - r.bottom < menuH + 12 && r.top > menuH + 12;
    const left = Math.max(8, Math.min(r.left, window.innerWidth - menuW - 8));
    setPos(up ? { bottom: window.innerHeight - r.top + 6, left } : { top: r.bottom + 6, left });
    setOpen(true);
  };

  return { open: open && !!pos, setOpen, pos, box, toggle };
}
